import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import authManager from '../lib/authManager';
import { withInstallation } from './InstallationContext';

export function _PermissionOnly({ installation, permissions, mode = 'any', children }) {
  const canAccess = authManager.canAccess(
    Array.isArray(permissions)
      ? { permissions, mode }
      : permissions || null,
    installation.id
  );

  if (!canAccess) {
    return null;
  }

  return children;
}

export function _PermissionRoute({
  installation,
  permissions,
  mode = 'any',
  component: Component,
  render,
  redirectTo = `/${installation.brandingKey}/profile`,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={(props) => {
        const canAccess = authManager.canAccess(
          Array.isArray(permissions)
            ? { permissions, mode }
            : permissions,
          installation.id
        );

        if (!canAccess) {
          return <Redirect to={redirectTo} />;
        }

        if (Component) {
          return <Component {...props} />;
        }

        if (render) {
          return render(props);
        }

        return null;
      }}
    />
  );
}

export function RootOnly({ children }) {
  if (!authManager.isRootAdmin()) return null;

  return children;
}

export const PermissionOnly = withInstallation(_PermissionOnly);
export const PermissionRoute = withInstallation(_PermissionRoute);
